module.exports = __webpack_public_path__ + "static/media/charge-sell.ff68ba6c.png";